<!-- src/components/Inventario/Reportes/ScrapAlmacenLaser/ScrapAlmacenLaserDashboard.vue -->
<template>
  <div class="sal-dashboard">
    <!-- Selector de periodos + productos -->
    <SALSelectorPeriodo
      :periodo-a="periodoA"
      :periodo-b="periodoB"
      :productos-seleccionados="productosSeleccionados"
      :mostrar-todos="mostrarTodos"
      :catalogo-productos="catalogoProductos"
      :cargando-productos="cargandoProductos"
      @update:periodo-a="actualizarPeriodoA"
      @update:periodo-b="actualizarPeriodoB"
      @update:productos-seleccionados="actualizarProductosSeleccionados"
      @update:mostrar-todos="actualizarMostrarTodos"
    />

    <!-- Cuerpo: panel resumen + gráfica de barras -->
    <div class="sal-dashboard__body">
      <SALPanelResumen
        :total-scrap-a="totalScrapA"
        :total-real-a="totalRealA"
        :porcentaje-scrap-a="porcentajeScrapA"
        :total-scrap-b="totalScrapB"
        :total-real-b="totalRealB"
        :porcentaje-scrap-b="porcentajeScrapB"
      />
      <div class="sal-dashboard__grafica">
        <div v-if="cargando" class="sal-dashboard__loading">Cargando datos...</div>
        <SALGraficaBarras
          v-else
          :datos-a="datosProductosA"
          :datos-b="datosProductosB"
          :filtro-activo="mostrarTodos || productosSeleccionados.length > 0"
          titulo="Piezas de Scrap reportadas en Almacén y Láser"
          :subtitulo="`${etiquetaPeriodo(periodoA)}  /  ${etiquetaPeriodo(periodoB)}`"
        />
      </div>
    </div>

    <!-- Sección Pareto -->
    <div class="sal-dashboard__pareto-seccion">
      <div class="sal-dashboard__pareto-header">
        <h4 class="sal-pareto-titulo">Análisis de Pareto — Defectos</h4>
      </div>
      <div class="sal-dashboard__grafica sal-dashboard__grafica--pareto">
        <div v-if="cargandoPareto" class="sal-dashboard__loading">Cargando Pareto...</div>
        <SALGraficaPareto
          v-else
          :datos="datosPareto"
          :subtitulo="etiquetaPeriodo(periodoA)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import SALSelectorPeriodo from "./components/SALSelectorPeriodo.vue";
import SALPanelResumen from "./components/SALPanelResumen.vue";
import SALGraficaBarras from "./components/SALGraficaBarras.vue";
import SALGraficaPareto from "./components/SALGraficaPareto.vue";
import { useScrapAlmacenLaser } from "./composables/useScrapAlmacenLaser";

import "./styles/scrap-almacen-laser.css";

const {
  cargando,
  cargandoProductos,
  periodoA,
  periodoB,
  productosSeleccionados,
  mostrarTodos,
  catalogoProductos,
  datosProductosA,
  totalScrapA,
  totalRealA,
  porcentajeScrapA,
  datosProductosB,
  totalScrapB,
  totalRealB,
  porcentajeScrapB,
  datosPareto,
  cargandoPareto,
  etiquetaPeriodo,
  cargarTodo,
  actualizarPeriodoA,
  actualizarPeriodoB,
  actualizarProductosSeleccionados,
  actualizarMostrarTodos,
} = useScrapAlmacenLaser();

onMounted(() => cargarTodo());
</script>
